import UserActive from "../logic/profile/sessionActive";
import Parks from "../logic/multimedios/parks"

export default {
    data: () => ({
        pathname: window.location.origin + "/",
        errorLogin: {
            username: false,
            password: false,
            email: false,
            birthdate: false,
            JoinedCode: false,
            ParkID: false,
            visitDate: false,
            tag: false,
            Code: false,
            HotelID: false,
            Room: false,
            ArrivalDate: false,
            DepartureDate: false,
            statusApiMessage: false,
            apiMessageErrorLogin: "*Nombre de usuario o contraseña incorrecta.",
            apiMessageErrorRegister: "*Ya existe una cuenta con el correo electrónico proporcionado.",
        },
        successLogin: {
            statusApiMessage: false,
            apiMessageErrorRecoveryPassword: "¡Te enviamos un enlace para restablecer tu contraseña!",
        },
        msgApi: {
            success: false,
            error: false,
            message: "",
        },
        activeForm: 0, //0
        allParkSelected: [],
        dontReload: false,
        componentKey: 0,
        paginator: {
            perPage: 30,
            page: 1,
            items: []
        },
        getUrlCode: '',
        activePark: 0,
        currentItem: [],
        isUnlock: 0,
        isVideo: 0,
        isTag: 0,
        isRoom: 0,
        VisitDate: "",
        GalleryEmpty: true,
    }),
    methods: {
        async sessionActive() {
            try {
                // Verificamos si la sesion aun sigue activa
                let response = await UserActive.get();
                
                this.activeForm = response.data == true ? 3 : 0; //0
                this.setUserLoggedIn(this.activeForm);
            } catch (error) {
                
            }
        },
        async getAllParks() {
            try {
                // Obtenemos todos los parques y hoteles
                let response = await Parks.get();
                let $UDNS = response.data;

                if (this.errorFormInput($UDNS, "errorCode")) {
                    this.errorCode = true;
                    this.errorCodeMsg = $UDNS.errorCodeMsg;
                } else {

                    this.$store.dispatch("AddParks", $UDNS);
                }
            } catch (error) {}
        },
        getAllCode() {
            let recoveredData = localStorage.getItem('code');
            recoveredData = JSON.parse(recoveredData);

            return recoveredData;
        },
        viewNewPark(DownloadCode, parkID) {
            this.getUrlCode = DownloadCode;
            this.activePark = Number(parkID);
            this.InitialParks();
        },
        paginationUpdate(page) {
            if (Boolean(page)) {
                page = parseInt(page.replace('/?page=', ''));
                this.paginator.page = page;
                this.page = page;
                this.InitialPhotos();
            }

        },
        errorFormInput(error, field) {
            return error.hasOwnProperty(field) ? true : false;
        },
        validFieldsRegister($errors) {
            this.disableAllInputs();

            if (this.errorFormInput($errors, "Username")) {
                // Input Username - Funcion para ver si hay error en el input email y settear su valor
                this.errorLogin.username = this.errorFormInput($errors, "Username");
            }

            if (this.errorFormInput($errors, "Email")) {
                // Input Email - Funcion para ver si hay error en el input email y settear su valor
                this.errorLogin.email = this.errorFormInput($errors, "Email");
            }

            if (this.errorFormInput($errors, "Password")) {
                // Input Password - Funcion para ver si hay error en el input Password y settear su valor
                this.errorLogin.password = this.errorFormInput($errors, "Password");
            }

            if (this.errorFormInput($errors, "Birthdate")) {
                // Input Birthdate - Funcion para ver si hay error en el input Birthdate y settear su valor
                this.errorLogin.birthdate = this.errorFormInput($errors, "Birthdate");
            }

            if (this.errorFormInput($errors, "JoinedCode")) {
                // Input JoinedCode - Funcion para ver si hay error en el input JoinedCode y settear su valor
                this.errorLogin.JoinedCode = this.errorFormInput($errors, "JoinedCode");
            }
            if (this.errorFormInput($errors, "ParkID")) {
                // Input ParkID - Funcion para ver si hay error en el input ParkID y settear su valor
                this.errorLogin.ParkID = this.errorFormInput($errors, "ParkID");
            }
            if (this.errorFormInput($errors, "visitDate")) {
                // Input visitDate - Funcion para ver si hay error en el input visitDate y settear su valor
                this.errorLogin.visitDate = this.errorFormInput($errors, "visitDate");
            }
            if (this.errorFormInput($errors, "tag")) {
                // Input tag - Funcion para ver si hay error en el input tag y settear su valor
                this.errorLogin.tag = this.errorFormInput($errors, "tag");
            }
            if (this.errorFormInput($errors, "Code")) {
                // Input tag - Funcion para ver si hay error en el input tag y settear su valor
                this.errorLogin.Code = this.errorFormInput($errors, "Code");
            }
            if (this.errorFormInput($errors, "HotelID")) {
                // Input tag - Funcion para ver si hay error en el input tag y settear su valor
                this.errorLogin.HotelID = this.errorFormInput($errors, "HotelID");
            }
            if (this.errorFormInput($errors, "Room")) {
                // Input tag - Funcion para ver si hay error en el input tag y settear su valor
                this.errorLogin.Room = this.errorFormInput($errors, "Room");
            }
            if (this.errorFormInput($errors, "ArrivalDate")) {
                // Input tag - Funcion para ver si hay error en el input tag y settear su valor
                this.errorLogin.ArrivalDate = this.errorFormInput($errors, "ArrivalDate");
            }
            if (this.errorFormInput($errors, "DepartureDate")) {
                // Input tag - Funcion para ver si hay error en el input tag y settear su valor
                this.errorLogin.DepartureDate = this.errorFormInput($errors, "DepartureDate");
            }

        },
        disableAllInputs() {
            this.errorLogin.statusApiMessage = false;
            this.errorLogin.username = false;
            this.errorLogin.email = false;
            this.errorLogin.password = false;
            this.errorLogin.birthdate = false;
            this.errorLogin.JoinedCode = false;
            this.errorLogin.ParkID = false;
            this.errorLogin.visitDate = false;
            this.errorLogin.tag = false;
            this.errorLogin.Code = false;
            this.errorLogin.HotelID = false;
            this.errorLogin.Room = false;
            this.errorLogin.ArrivalDate = false;
            this.errorLogin.DepartureDate = false;
        },
        setActiveWindow(value) {
            this.activeForm = value;
            
        },
        UpperCase($element) {
            return $element.target.value.toUpperCase();
        },
        getIDfromURL(position) {
            return window.location.pathname.split('/')[position];
        },
        makeToast(variant = null, msg = null) {
            this.$bvToast.toast(`${msg}`, {
                title: `Mensaje`,
                variant: variant,
                solid: true,
                autoHideDelay: 8000
            })
        },
    },
};